import { Link } from 'react-router-dom';
import type { categories as CategoriesType } from '@/mocks/categories';

interface CategoryTabsProps {
  categories: typeof CategoriesType;
  activeSlug?: string;
}

export default function CategoryTabs({ categories, activeSlug }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-3">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
          !activeSlug
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-700 hover:bg-background-200/70'
        }`}
      >
        全部文章
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap flex items-center gap-2 ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200/70'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
          <span className={`text-xs px-1.5 py-0.5 rounded-full ${
            activeSlug === cat.slug
              ? 'bg-background-50/20 text-background-50'
              : 'bg-background-200/70 text-foreground-500'
          }`}>
            {cat.articleCount}
          </span>
        </Link>
      ))}
    </div>
  );
}